module.exports = __webpack_public_path__ + "static/media/vihara.17b9e104.svg";